import AssetClass from '@advisor/models/store/settings/investmentSetup/AssetClass';
import SecurityClassification from '@advisor/models/store/settings/investmentSetup/SecurityClassification';

export default class InvestmentSetup {
  constructor() {
    this.assetClass = new AssetClass();
    this.securityClassification = new SecurityClassification();
    this.customAssetClassHierarchy = [];
    this.rwAssetClassHierarchy = [];
    this.arrCustomTickerAssetClasses = [];
    this.arrCustomHoldingsAssetClasses = [];
  }
}
